export type Settings =  Record<string,any>

export type SettingsType = string

export type AppSettings = Record<SettingsType,Settings>

// the devtools bag slot: a shared name so apps (who stage it) and libraries (who read it) agree on the key.
export const devtoolsSlot = 'devtools'

export const settingsChangeTopic = 'settings'

export type SettingsChangeEvent = {
    settings: AppSettings
}


